// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hh-6";
export var emphasizeQuantity = "_hh-3";
export var flatBottomCorners = "_hh-5";
export var productImage = "_hh-0";
export var quantityContainer = "_hh-2";
export var tooltip = "_hh-1";
export var wrapAndEllipsesOverflow = "_hh-4";